<template>
  <div class="selected-files-container">
    <v-toolbar density="compact" flat color="grey-lighten-4" class="rounded-t">
      <v-toolbar-title class="text-subtitle-2">Selected for Processing</v-toolbar-title>
    </v-toolbar>
    <div class="tree-text-area border rounded-b">
      <pre><code>{{ fileTree }}</code></pre>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { renderTree, pathsToNestedObject } from '@/utils/fileTree'

const { filePaths } = defineProps({
  filePaths: {
    type: Array,
    required: true,
    default: () => []
  }
})

const fileTree = computed(() => {
  if (filePaths.length === 0) {
    return 'No files selected.'
  }
  const nestedObject = pathsToNestedObject(filePaths)

  return renderTree(nestedObject)
})

</script>

<style scoped>
.tree-text-area {
  background-color: var(--light-1);
  padding: 16px;
  max-height: 516px;
  overflow: auto;
  white-space: pre;
}

.tree-text-area pre {
  margin: 0;
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.8rem;
  line-height: 1.5;
}

.border {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.rounded-t, .rounded-b {
  border-radius: inherit;
}

[data-theme="dark"] .selected-files-container :deep(.v-toolbar.bg-grey-lighten-4) {
  background-color: var(--light-2) !important;
  color: var(--text-dark) !important;
}
</style>
